import React, { useContext, useState } from 'react'
import {IoMdArrowDropdown} from 'react-icons/io'
import Renderif from './renderif'
import { createContext } from "react";

const DropDownContext = createContext();

export default function DropDown({
    title = 'Seleccionar', 
    styles='',
    open = false, 
    defaultValue = -1, 
    children,
    _onChange = ()=>{}, 
    icon = null, 
    style='light',
    direction='bottom-left'
}) {
   


    const defaultValue2 = children?.length === undefined ? children?.props.value : children?.filter((item)=>item.props.value === defaultValue)[0]?.props?.value;
    const defaultLabel = children?.length === undefined ? children?.props.label : children?.filter((item)=>item.props.value === defaultValue)[0]?.props?.label;

    const [state, setState] = useState({
        open:open,
        value: defaultValue2,
        label: defaultLabel
    })

    const onChange = ({value, label}) => {
        
        setState({
            ...state,
            open:false,
            value,
            label
        })

        let result = {
            value,
            label
        }
        console.log(result)
        _onChange(result)
    }

  return (
    <DropDownContext.Provider value={{
        onChange

    }}>
           <div className={`bv-dropdown bv-dropdown--${style} ${styles}`} onClick={()=>{
                setState({...state, open:!state.open})
            }}>

           
                
                        
                        <div>
                            <Renderif isTrue={title !== ''}><div className={`bv-dropdown-title`}>{title}</div></Renderif>
                            <div className='text-black bold f-12'>{state.label}</div>
                        </div>

                        <Renderif isTrue={title !== ''}>
                            <div className='col'></div>
                        </Renderif>


                        <div className='line-0 '>
                            {icon === null ? 
                            <IoMdArrowDropdown size={26} color="#999" />
                            :icon }
                        </div>

              
           


            <Renderif isTrue={state.open}>
                <div className={`bv-dropdown-option bv-dropdown-option--${direction}`}>
                    {children}
                </div>
            </Renderif>
            </div>
    </DropDownContext.Provider>
 
  )
}

export function DropDownOption({children, value, label, disabled}) {

    const {onChange} = useContext(DropDownContext);
  return (
    <div className={` ${ disabled ? 'cursor-auto' :'highlight-hover cursor-pointer'} b-bottom px-2 py-2 f-14`} onClick={(e) => {
        e.stopPropagation();
        if(!disabled){     
        
            onChange({value, label})
        }
    }}>{children}</div>
  )
}
